import React from 'react'
import { Button, Form, Input , DatePicker, Spin } from 'antd'
import Icon from '@assets/icon_config'
import moment from 'moment'
import './edit.scss'
import { EditProvider, useEditContext, UseEditProps } from './useEdit'
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

export type EditProps = {
}

export const View: React.FC<EditProps> = () => {
  const {
    loading,
    form,
    onSubmit
  } = useEditContext()

  return (
    <div className="ui-edit-weight">
      <div className="ui-edit-weight__header">
        <div className="ui-edit-weight__header__title">
          Weight
        </div>
        <div className="ui-edit-weight__header__actions">
          <Spin spinning={loading} indicator={<HealthemSpinner size={70}/>}>
            <Button
              type="primary"
              color="primary"
              className="ui-edit-weight__header__actions__save-btn"
              onClick={
                () => {
                  form && form.submit()
                }
              }
            >
              Save
            </Button>
          </Spin>
        </div>
      </div>
      <div className="ui-edit-weight__form">
        <Form
          form={form}
          name='edit'
          layout='vertical'
          onFinish={
            (values) => {
              onSubmit && onSubmit(values)
            }
          }
        >
          <Form.Item
            name='weight'
            label='Enter Weight'
            className="ui-edit-weight__form__item "
            rules={
              [
                {
                  required: true,
                  message: 'Please enter Weight!',
                }
              ]
            }
          >
            <Input type="number" placeholder="000.00 Lbs" />
          </Form.Item>
          <Form.Item
            name='date'
            label='Recorded Date'
            className="ui-edit-weight__form__item ui-edit-weight__form__item--date"
            rules={
              [
                {
                  required: true,
                  message: 'Please select Recorded Date!',
                }
              ]
            }
          >
            <DatePicker
              format='MM-DD-YYYY'
              suffixIcon={<Icon name="calender" />}
              disabledDate={
                (value) => value.isAfter(moment().endOf('d'))
              }
            />
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export const Edit: React.FC<UseEditProps> = (props) => {
  return <EditProvider {...props}>
    <View />
  </EditProvider>
}
